module.exports = __webpack_public_path__ + "static/happyitaly-59a4b9b06791c3b8f3c60868f4ba4bb7.png";